import React from 'react';
import { Card, CardTitle, CardText } from 'react-md';

import './StickerWorkshop.css'

export default (props) => (
  <div>
    <Card>
      <CardTitle title="Letzter Zugriff" />
      <CardText>
        Workshop
      </CardText>
    </Card>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/stickers/StickerWorkshop.jsx